import { Pipe } from '@angular/core';
import { isArray, takeUntil, isNil } from '../utils/utils';
var TakeUntilPipe = (function () {
    function TakeUntilPipe() {
    }
    TakeUntilPipe.prototype.transform = function (input, predicate) {
        if (!isArray(input) || isNil(predicate)) {
            return input;
        }
        return takeUntil(input, predicate);
    };
    return TakeUntilPipe;
}());
export { TakeUntilPipe };
TakeUntilPipe.decorators = [
    { type: Pipe, args: [{
                name: 'takeUntil'
            },] },
];
/** @nocollapse */
TakeUntilPipe.ctorParameters = function () { return []; };
//# sourceMappingURL=take-until.pipe.js.map


//////////////////
// WEBPACK FOOTER
// ./~/angular-pipes/esm/array/take-until.pipe.js
// module id = 249
// module chunks = 103